import { getTabbableElements } from './tabbableHelper';

export const SCREEN_CONTENT_SELECTOR = '.main-container';

const ENTRY_PENDING_SELECTOR = '[data-entry-pending]';
const FLOATING_ACTION_SELECTOR = '[data-floating-action]';

/** Most specific first: the control the screen asks for, its search box, first list item, first form field. */
const ENTRY_PREFERENCES: ((candidate: HTMLElement) => boolean)[] = [
  (candidate) => candidate.closest('[data-entry-focus]') !== null,
  (candidate) => candidate.matches('input[data-list-search]'),
  (candidate) => candidate.matches('[data-keyboard-item]'),
  (candidate) => candidate.closest('form') !== null,
];

export const findScreenEntryTarget = (content: HTMLElement) => {
  if (content.querySelector(ENTRY_PENDING_SELECTOR)) return undefined;
  const candidates = getTabbableElements(content).filter(
    (candidate) => !candidate.closest(FLOATING_ACTION_SELECTOR),
  );
  for (const prefers of ENTRY_PREFERENCES) {
    const match = candidates.find(prefers);
    if (match) return match;
  }
  return candidates[0];
};
